import { VideoInputHdmiIcon } from './VideoInputHdmiIcon';

/**
 * author: Google
 * id D371C4A6-40A8-4C03-95DA-2ACF2A5ABC4B
 * name video-input-hdmi
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/video-input-hdmi.svg
 * tags
 * - Video / Movie 
 */
export const SettingsInputHdmiIcon = VideoInputHdmiIcon;
export default SettingsInputHdmiIcon